import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import type EstimateValues from "../../../types/params"

const isValidMetalMask = (values: EstimateValues, metalMask?: string, hasGhMetalMask?: boolean) => {
  const isNoBGA = (values.bgacsp ?? 0) <= 0

  switch (metalMask) {
    case ESTIMATE_CONSTANT.実装方法.手付実装をする.value:
      // GugenHubでメタルマスク在庫を選択している場合、メタルマスクはリフロー実装用のため手付実装は非表示
      if (hasGhMetalMask) return false
      return isNoBGA

    case ESTIMATE_CONSTANT.実装方法.リフロー実装をする.value:
    // 初期値が未選択状態なためtrueを返す
    default:
      return true
  }
}

export default isValidMetalMask
